export const ATTACH = 'attach'
export const DOC_PDF = 'pdf'
export const DOC_ZIP = 'zip'
export const DOC_XLS = 'xls'
export const DOC_XLSX = 'xlsx'



